


























































































import Vue from 'vue';
import authService, { IToken } from './services/auth.service';
import restService from './services/rest.service';
import messagingService from './services/messaging.service';
import wizardService from './services/wizard.service';
import shopService from './services/shop.service';
import arenaService from './services/arena.service';
import solidPancakeService from './services/solid-pancake.service';
import optionsService from './services/options.service';
import Options from './components/Options.vue';
import Tchat from './components/Tchat.vue';
import { IWizard } from '@thefirstspine/types-arena';
import { Route } from 'vue-router';
import websiteService from './services/website.service';
import calendarService from './services/calendar.service';
import LootToaster from '@/components/LootToaster.vue';

export default Vue.extend({

  components: {
    Options,
    Tchat,
    LootToaster,
  },

  async mounted() {
    // Set language based on options
    this.$i18n.locale = optionsService.options.language as string;

    // Create session to SolidPancake
    solidPancakeService.createSession(
      'arena',
      navigator.platform,
      process.env.VUE_APP_VERSION);
    solidPancakeService.addEvent(
      'viewPage',
      'navigation',
      '/');

    // Cycle loading
    this.$data.cycle = await calendarService.currentCycle();

    // App should be only compatible with a certain amount of cycle
    if (!['treasure-2021', 'souvenirs-2021', 'fire-2021', 'harvest-2021', 'crowned-souls-2021', 'snow-man-2021', 'renewal-2022', 'drifter'].includes(this.$data.cycle.name)) {
      alert(`Votre application n'est pas compatible avec le cycle en cours.
Vous pouvez aller sur www.thefirstspine.fr pour mettre à jour votre client.`);
      return;
    }

    // Subscribe
    authService.isLogged.subscribe(() => {
      this.callLoginRefresh();
    });

    // Go to home
    this.$router.push('/');

    // Call refreshs
    await this.callLoginRefresh();
    await this.callGameRefresh();

    // Load available events
    try {
      const events = (await calendarService.currentEvents());
      this.$data.availableEvents = events.map((e: any) => e.type);
    } catch (e) {
      // do nothing
    }
  },

  watch: {
    $route(to: Route, from: Route) {
      // Add event to SolidPancake
      solidPancakeService.addEvent(
        'viewPage',
        'navigation',
        to.path);
      if (to.path === '/' && from.path === '/game') {
        this.callAccountRefresh();
      }
    },
  },

  methods: {
    async callLoginRefresh() {
      try {
        await authService.me();
        await messagingService.connect();
        await this.callAccountRefresh();
        messagingService.subscribe({
          subject: 'TheFirstSpine:shop',
          handler: () => {
            this.callAccountRefresh();
          },
        });
        this.$data.isLogged = true;
      } catch (e) {
        this.$data.isLogged = false;
      } finally {
        this.$data.curtains = false;
      }
    },

    async callAccountRefresh() {
      const wizzard: IWizard = await wizardService.getMe();
      if (!wizzard.publicRoom) {
        wizardService.setMe({
          publicRoom: optionsService.options.language as ('fr'|'en'),
        });
        wizzard.publicRoom = optionsService.options.language as ('fr'|'en');
      }
      this.$data.shards = wizzard.items
        .reduce((acc: number, curr: any) => acc + (curr.name === 'shard' ? curr.num : 0), 0);
      this.$data.runes = wizzard.items
        .reduce(
          (acc: number, curr: any) =>
            acc + (['rune-solid', 'rune-holo', 'rune-ghostly'].includes(curr.name) ? curr.num : 0),
          0);
      this.$data.coins = wizzard.items
        .reduce((acc: number, curr: any) => acc + (curr.name === 'coin' ? curr.num : 0), 0);
      this.$data.goldenGalleons = wizzard.items
        .reduce((acc: number, curr: any) => acc + (curr.name === 'golden-galleon' ? curr.num : 0), 0);
      this.$data.candyShards = wizzard.items
        .reduce((acc: number, curr: any) => acc + (curr.name === 'candy-shard' ? curr.num : 0), 0);
    },

    async callGameRefresh() {
      if (!this.$data.isLogged) {
        return;
      }
      try {
        const getGameResponse = await arenaService.getCurrentGame();
        if (getGameResponse && getGameResponse.id) {
          // TODO: better alert here
          const response: boolean = confirm(`Aller à la partie en cours ?`);
          if (response) {
            this.$router.push(`/game?gameId=${getGameResponse.id}`);
          }
        }
      } catch {
        // do nothing as we do not found any opened game instance for this user
      }
    },

    isInMatch() {
      const matchesPaths: string[] = [
        '/game',
      ];
      return matchesPaths.includes(this.$route.path);
    },

    isInMatchMaking() {
      const matchesPaths: string[] = [
        '/matchmaking',
      ];
      return matchesPaths.includes(this.$route.path);
    },

    displayMenu() {
      // Top menu does not displays in match...
      if (this.isInMatch()) {
        return false;
      }

      // ...or in matchmaking...
      if (this.isInMatchMaking()) {
        return false;
      }

      // ...or while not logged...
      if (['/login'].includes(this.$route.path)) {
        return false;
      }

      // ...or when language not set...
      if (['/select-language'].includes(this.$route.path)) {
        return false;
      }

      // ...or when realm not set.
      if (['/select-realm'].includes(this.$route.path)) {
        return false;
      }

      return true;
    },
  },

  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      betaMessage: true,
      isLogged: false,
      curtains: true,
      shards: 0,
      runes: 0,
      coins: 0,
      goldenGalleons: 0,
      candyShards: 0,
      cycle: null,
      env: process.env.VUE_APP_ENV,
      options: optionsService.options,
      tchatVisible: false,
      availableEvents: [],
    };
  },
});
